import { useCallback, useRef } from 'react';
import { isIOS, isMobile } from 'react-device-detect';
import { isNativeIOS } from '@pocapan/shared/utils/NativeUtil';

interface UseIOSKeyboardSheetPaddingOptions {
  enabled?: boolean;
  paddingBottom?: string;
  touchDelayMs?: number;
}

/**
 * iOS 모바일 웹(특히 Safari/WebView)에서 키보드가 올라올 때,
 * bottom-sheet 콘텐츠 영역에 padding-bottom을 강제로 추가해
 * 입력 필드/버튼이 키보드에 가려지지 않도록 돕는 유틸 훅입니다.
 */
export function useIOSKeyboardSheetPadding(options: UseIOSKeyboardSheetPaddingOptions = {}) {
  const { enabled = true, paddingBottom = '360px', touchDelayMs = 150 } = options;

  const containerRef = useRef<HTMLDivElement>(null);

  const handleFocus = useCallback((): void => {
    if (!enabled) return;
    if (isNativeIOS()) return;
    if (containerRef.current && isMobile && isIOS) {
      containerRef.current.style.paddingBottom = paddingBottom;
    }
  }, [enabled, paddingBottom]);

  const handleBlur = useCallback((): void => {
    if (!enabled) return;
    if (isNativeIOS()) return;
    if (containerRef.current && isMobile && isIOS) {
      containerRef.current.style.paddingBottom = '0px';
    }
  }, [enabled]);

  const handleTouchStart = useCallback((): void => {
    if (!enabled) return;
    window.setTimeout(() => {
      handleFocus();
    }, touchDelayMs);
  }, [enabled, handleFocus, touchDelayMs]);

  return {
    containerRef,
    handleFocus,
    handleBlur,
    handleTouchStart
  };
}
